<template>
<div class="dropdown-container" ref="container">
    <button
        class="btn btn-light border-top border dropdown-toggle"
        @click="togglePopup"
        ref="button"
        v-click-outside="closePopup"
    >
      <icon name="book"/>
        目錄
    </button>
    <div
      v-if="showPopup"
      class="popup"
      :style="popupStyle"
      ref="popup"
    >
      <ul>
        <li v-for="(text, index) in versions" :key="index" @click.stop="() => gotoUrl(readerPassageURL(text.urn))">
          <div :href="readerPassageURL(text.urn)" class="version-link">{{ text.label }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Skeleton2NavigationMixin from "@/js/mixins/Skeleton2NavigationMixin.vue";

export default {
  props: ['texts'],
  mixins: [Skeleton2NavigationMixin],
  data() {
    return {
      showPopup: false,
      popupStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px'
      },
    };
  },
  computed: {
    versions() {
      return this.texts;
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        // Click outside
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);

        // Keydown handler for Escape
        el.keydownEvent = function(event) {
          if (event.key === 'Escape') {
            binding.value(event);
          }
        };
        document.addEventListener('keydown', el.keydownEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.removeEventListener('keydown', el.keydownEvent);
      }
    }
  },
  methods: {
    togglePopup() {
      this.showPopup = !this.showPopup;
      this.$nextTick(() => {
        if (this.showPopup) {
          this.positionPopup();
        }
      });
    },
    closePopup() {
       this.showPopup = false;
    },
    positionPopup() {
      const button = this.$refs.button;
      const popup = this.$refs.popup;

      const buttonRect = button.getBoundingClientRect();
      const popupRect = popup.getBoundingClientRect();

      const spaceBelow = window.innerHeight - buttonRect.bottom;
      const spaceAbove = buttonRect.top;
      const showAbove = spaceBelow < popupRect.height && spaceAbove > popupRect.height;

      this.popupStyle.top = `${showAbove ? - popupRect.height : buttonRect.height}px`;
      this.popupStyle.left = `${buttonRect.width - popupRect.width}px`;
    },
    readerPassageURL(urn) {
      return this.getReaderURL({ urn });
    },
    gotoUrl(href) {
      //this.$router.push(href)
      document.location = href;
    }
  }
};
</script>

<style scoped>
.dropdown-container {
  position: relative;
}

.popup {
  border: 1px solid #ccc;
  background: white;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  width: 300px;
  z-index: 1000;
  max-height: 350px;
  overflow: scroll;
}
.popup ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.popup li {
  padding: 8px 12px;
  cursor: pointer;
}
.popup li:hover {
  background-color: #f0f0f0;
}
.popup li a {
  text-decoration: none;
  display: inline-block;
  width: 100%;
}

</style>
